import { t } from "i18next";

/**
 * Get an error message from the translations with optional parameters.
 * @param key The key for the error message.
 * @param params Optional parameters for dynamic placeholders in the message.
 * @returns The translated error message.
 */
export const getErrorMessage = (
  key: string,
  params?: Record<string, string | number>
): string => {
  return t(`errors.${key}`, params);
};

/**
 * Get an error message from the translations with optional parameters.
 * @param key The key for the error message.
 * @param params Optional parameters for dynamic placeholders in the message.
 * @returns The translated error message.
 */
export const getSuccessMessage = (
  key: string,
  params?: Record<string, string | number>
): string => {
  return t(`success.${key}`, params);
};

/**
 * Get a UI interface text from the translations with optional parameters.
 * @param key The key for the UI text.
 * @param params Optional parameters for dynamic placeholders in the text.
 * @returns The translated UI text.
 */
export const getUiInterface = (
  key: string,
  params?: Record<string, string | number>
): string => {
  return t(`uiInterface.${key}`, params);
};

/**
 * Get a page name from the translations with optional parameters.
 * @param key The key for the page name.
 * @param params Optional parameters for dynamic placeholders in the name.
 * @returns The translated page name.
 */
export const getPageName = (
  key: string,
  params?: Record<string, string | number>
): string => {
  return t(`pageName.${key}`, params);
};

/**
 * Get a word connector (e.g., "and", "or", "e") from the translations with optional parameters.
 * @param key The key for the word connector.
 * @param params Optional parameters for dynamic placeholders in the connector.
 * @returns The translated word connector.
 */
export const getWordConnector = (
  key: string,
  params?: Record<string, string | number>
): string => {
  return t(`wordConnector.${key}`, params);
};

/**
 * Get a page description from the translations with optional parameters.
 * @param key The key for the page description.
 * @param params Optional parameters for dynamic placeholders in the description.
 * @returns The translated page description.
 */
export const getPageDescription = (
  key: string,
  params?: Record<string, string | number>
): string => {
  return t(`pageDescription.${key}`, params);
};
